<pannel [title]="getTitle()" [expandable]="true" [folded]="foldedPannel" 
	[ngClass]= "highlightable && dataSource.data.length > 0 && isCacOrCc() ? 'highlightable' : ''" >
	<div class="mat-elevation-z4">
		<table mat-table matSort [dataSource]="dataSource" style="width: 100%" class="acces-liste">
			<ng-container matColumnDef="batch">
				<th mat-header-cell *matHeaderCellDef
					mat-sort-header
				> Batch </th>
				<td mat-cell *matCellDef="let acces"
					click-stop-propagation
					(click)="true;"
					>
					<a style="cursor: pointer" (click)="executionIdClicked(acces); $event.stopPropagation();" *ngIf="acces.jobExecutionId">{{ acces.jobExecutionId }}</a>
					<span *ngIf="acces.batchId">{{ acces.batchId }}</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="numero">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Numéro </th>
				<td mat-cell *matCellDef="let acces"> {{ acces.numero }}</td>
			</ng-container>
			
			<ng-container matColumnDef="antenneNom">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Antenne </th>
				<td mat-cell *matCellDef="let acces"> {{ acces.antenneNom }} </td>
			</ng-container>
			
			<ng-container matColumnDef="parcCode">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Parc </th>
				<td mat-cell *matCellDef="let acces"> 
					<i class="parc-energie fa {{ acces.parcIcon }}" title="{{ acces.parcEnergie }}"></i>{{ acces.parcCode }} ({{ acces.parcDescription }})
				</td>
			</ng-container>
			
			<ng-container matColumnDef="ouvrageNoms">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Ouvrage(s) </th>
				<td mat-cell *matCellDef="let acces" title="{{ acces.ouvrageNoms }}">
					<etat-ouvrage [accesId]="acces.id" [ouvrageNoms]="acces.ouvrageNoms" *ngIf="title === 'Accès Terminé'" ></etat-ouvrage>
					<span *ngIf="title !== 'Accès Terminé'">{{ acces.ouvrageNoms | truncate:[24, '...'] }}</span>
				</td>
			</ng-container>
			
			<ng-container matColumnDef="ouvrageConcernes">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Ouvrage(s) concerné(s) </th>
				<td mat-cell *matCellDef="let acces" title="{{ acces.ouvrageConcernes }}"> {{ acces.ouvrageConcernes | truncate:[24, '...'] }} </td>
			</ng-container>
			
			<ng-container matColumnDef="etat">
				<th mat-header-cell *matHeaderCellDef> &nbsp;Etat&nbsp; </th>
				<td mat-cell *matCellDef="let acces">
					<i class="fa fa-calendar fa-lg" alt="Planifié" title="Planifié" *ngIf="acces.etat==='ETAT_ENREGISTRE'"></i>
					<i class="fa-regular fa-circle-question fa-lg en-attente" alt="Entrée demandée" title="Entrée demandée" *ngIf="acces.etat==='ETAT_DEMANDE_ENTREE'"></i>
					<i class="fa-regular fa-clock fa-lg text-active" alt="En cours" title="En cours" *ngIf="acces.etat==='ETAT_EN_COURS'"></i>
					<i class="fa fa-pause fa-lg text-active" alt="En attente de fermeture" title="En attente de fermeture" *ngIf="acces.etatDemandeFermeture"></i>
					<i class="fa-regular fa-square-check fa-lg text-success" alt="Terminé" title="Termin&eacute;" *ngIf="acces.etat==='ETAT_TERMINE'"></i>
					<i class="fa fa-minus-circle fa-lg text-alert" alt="Refusé" title="Refusé" *ngIf="acces.etat==='ETAT_REFUSE'"></i>
				</td>
			</ng-container>
			
			<ng-container matColumnDef="cac">
				<th mat-header-cell *matHeaderCellDef > Valideur </th>
				<td mat-cell *matCellDef="let acces">
					{{ acces.valideurNom ? acces.valideurNom : acces.cacNom }} {{ acces.etat==='ETAT_ENREGISTRE' && acces.ccNom ? ' / ' + acces.ccNom : '' }}
				</td>
			</ng-container>
			
			<ng-container matColumnDef="entrepriseNoms">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Entreprise </th>
				<td mat-cell *matCellDef="let acces" title="{{ acces.entrepriseNoms }}">{{ acces.entrepriseNoms | truncate:[24, '...'] }} </td>
			</ng-container>
			
			<ng-container matColumnDef="chargeAcces">
				<th mat-header-cell *matHeaderCellDef> Intervenants </th>
				<td mat-cell *matCellDef="let acces" title="{{ acces.chargeAcces }}">{{ acces.intervenants | truncate:[24, '...'] }} </td>
			</ng-container>
			
			<ng-container matColumnDef="dateDebut">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Début </th>
				<td mat-cell *matCellDef="let acces"> {{ acces.dateDebut  | localDateTimeToDate: acces.ice | date : 'dd/MM/yyyy HH:mm' }}</td>
			</ng-container>
			
			<ng-container matColumnDef="dateAutorisation">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Autorisé le </th>
				<td mat-cell *matCellDef="let acces"> {{ acces.dateAutorisation  | localDateTimeToDate: acces.ice | date : 'dd/MM/yyyy HH:mm' }}</td>
			</ng-container>
			
			<ng-container matColumnDef="controleSecurite">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Contrôle sécurité </th>
				<td mat-cell *matCellDef="let acces">
					<span title="{{ acces.controleSecurite ? controleSecuriteLabels[acces.controleSecurite] : '' }}">
						{{ acces.controleSecurite ? controleSecurite[acces.controleSecurite] : '' }}
					</span>
				</td>
			</ng-container>
			
			<ng-container matColumnDef="dateFin">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Fin </th>
				<td mat-cell *matCellDef="let acces"> {{ acces.dateFin  | localDateTimeToDate: acces.ice | date : 'dd/MM/yyyy HH:mm' }}</td>
			</ng-container>
			
			<ng-container matColumnDef="dateFermeture">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Date Refus </th>
				<td mat-cell *matCellDef="let acces"> {{ acces.dateFermeture  | localDateTimeToDate: acces.ice | date : 'dd/MM/yyyy HH:mm' }}</td>
			</ng-container>
			
			<ng-container matColumnDef="motifRefus">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Cause </th>
				<td mat-cell *matCellDef="let acces"> {{ applicationConstants.motifRefus[acces.motifRefus] }}</td>
			</ng-container>
			
			<ng-container matColumnDef="operationIds">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Référence externe et acte O&M </th>
				<td mat-cell *matCellDef="let acces" class="popover__wrapper">
					<span *ngFor="let operationId of acces.operations">{{ operationId }}<br/></span>
					<span *ngFor="let workorderNumber of acces.workorderNumbers">{{ workorderNumber }}<br/></span>
					<span *ngFor="let notificationNumber of acces.notificationNumbers">{{ notificationNumber }}<br/></span>
					<div class="popover__content">
						<div class="panel panel-default">
							<div class="panel-heading" role="document">
								<h3>Acces {{acces.numero}}</h3>
							</div>
							<div class="panel-body">
								<div class="section">
									<div class="title">Commentaire:</div>
									<span class="field with-break-word">{{acces.commentaire}}</span>
								</div>
								<div class="section" *ngIf="acces.operations.length > 0">
									<div class="title">Opérations:</div>
									<ul><li class="field" *ngFor="let operationId of acces.operations">{{ operationId }}{{ acces.acteOnm ? ' : ' + acces.acteOnm : '' }}</li></ul>
								</div>
								<div class="section" *ngIf="acces.acteOnm">
									<div class="title">Opérations:</div>
									<ul>
										<ng-container *ngFor="let acte of split(acces.acteOnm, ';')">
										       <li class="field">{{ acte }}</li>
										</ng-container>
									</ul>
								</div>
								<div class="section" *ngIf="acces.listWorkorders.length === 0">
									<div class="title">Work Orders:</div>
									<span class="field">Aucun Work Order lié</span>
								</div>
								<div class="section" *ngIf="acces.listWorkorders.length > 0">
									<div class="title">Work Orders:</div>
									<ul>
										<li class="field" *ngFor="let wo of acces.listWorkorders">{{ wo }}</li>
									</ul>
								</div>
								<div class="section" *ngIf="acces.listNotifications.length === 0">
									<div class="title">Notifications:</div>
									<span class="field">Aucune notification liée</span>
								</div>
								<div class="section" *ngIf="acces.listNotifications.length > 0">
									<div class="title">Notifications:</div>
									<ul>
										<li class="field" *ngFor="let notification of acces.listNotifications">{{ notification }}</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
			</ng-container>
			
			<ng-container matColumnDef="actions">
				<th mat-header-cell *matHeaderCellDef> Actions </th>
				<td mat-cell *matCellDef="let acces" class="actions">
					<ng-container [ngTemplateOutlet]="acces.parcActif ? someActions : noAction" [ngTemplateOutletContext]="{ acces: acces }" >
		    		</ng-container>
				</td>
			</ng-container>
			
			<ng-container matColumnDef="check">
				<th mat-header-cell *matHeaderCellDef class="actions"
					style="white-space: nowrap">
					<a *ngFor="let action of allowedMassActions"
						[title]="action.title"
						click-stop-propagation >
						<i [ngClass]="[action.class, action.enabled ? action.validClass : 'text-disable']" (click)="action.action()"></i>
					</a>
					<br />
					<input type="checkbox"
						click-stop-propagation
						[ngModel]="allSelected"
						(ngModelChange)="onAllSelectedChange($event)"
						/>
				</th>
				<td mat-cell *matCellDef="let acces" class="actions"
					click-stop-propagation
					(click)="true;"
					>
					<input type="checkbox"
						click-stop-propagation
						[ngModel]="selected[acces.id]"
						(ngModelChange)="onAccesSelectedChange(acces.id, $event)"
						/>
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let acces columns: displayedColumns" 
				(click)="onRowClicked(acces)" [ngClass]= "acces.etat === 'ETAT_EN_COURS' ? 'with-red-bg' : ''" >
			
			</tr>
		</table>
		<mat-paginator #paginator
			showFirstLastButtons
			[pageSizeOptions]="[10, 20, 50, 100]"
			[pageSize]="pageSize"
			aria-label="Choisissez une page">
		</mat-paginator>
	</div>		
	<div class="navbar">
		<button type="button" class="btn btn-primary" (click)="exportRequest$.next()">Exporter</button>
	</div>
</pannel>

<ng-template #noAction let-acces="acces">
	<span class="text-active">Parc inactif </span>
</ng-template>

<ng-template #someActions let-acces="acces">
	<a title="Autoriser l'accès"  (click)="requestAction(accesAction.AUTORISER, [acces])" click-stop-propagation
		*ngIf="canAuthorizeAcces(acces)">
		<i class="fa-regular fa-thumbs-up fa-lg text-success"></i>
	</a>
	<a title="Autorisation impossible, intervenants non renseignés" click-stop-propagation
		*ngIf="(acces.etat === 'ETAT_ENREGISTRE' || acces.etat === 'ETAT_DEMANDE_ENTREE') && (user.id === acces.cacId || (user.id === acces.ccId && acces.typeAcces === 'A_DISTANCE')) && acces.entrepriseSeuls && autorisationPossible(acces)">
		<i class="fa-regular fa-thumbs-up fa-lg text-disable"></i>
	</a>
	<a title="Vous ne pouvez pas autoriser un accès dans le futur" click-stop-propagation
		*ngIf="(acces.etat === 'ETAT_ENREGISTRE' || acces.etat === 'ETAT_DEMANDE_ENTREE') && (user.id === acces.cacId || (user.id === acces.ccId && acces.typeAcces === 'A_DISTANCE')) && !acces.entrepriseSeuls && !autorisationPossible(acces)">
		<i class="fa-regular fa-thumbs-up fa-lg text-disable"></i>
	</a>
	<a title="Demander la validation" (click)="requestAction(accesAction.DEMANDE_VALIDATION, [acces])" click-stop-propagation
		*ngIf="canAskValidationAcces(acces)">
		<i class="fa-regular fa-hand-pointer fa-lg"></i>
	</a>
	<a title="Refuser l'accès" (click)="requestAction(accesAction.REFUSER, [acces])" click-stop-propagation
		*ngIf="canDenyAcces(acces)">
		<i class="fa-regular fa-thumbs-down fa-lg text-active"></i>
	</a>
	<a title="Refus impossible, intervenants non renseignés" click-stop-propagation
		*ngIf="(acces.etat === 'ETAT_ENREGISTRE' || acces.etat === 'ETAT_DEMANDE_ENTREE') && (user.id === acces.cacId || (user.id === acces.ccId && acces.typeAcces === 'A_DISTANCE')) && acces.entrepriseSeuls && refusPossible(acces)">
		<i class="fa-regular fa-thumbs-down fa-lg text-disable"></i>
	</a>
	<a title="Vous ne pouvez pas refuser un accès dans le futur" click-stop-propagation
		*ngIf="(acces.etat === 'ETAT_ENREGISTRE' || acces.etat === 'ETAT_DEMANDE_ENTREE') && (user.id === acces.cacId || (user.id === acces.ccId && acces.typeAcces === 'A_DISTANCE')) && !acces.entrepriseSeuls && !autorisationPossible(acces)">
		<i class="fa-regular fa-thumbs-down fa-lg text-disable"></i>
	</a>
	<a title="Fermer l'accès" (click)="requestAction(accesAction.FERMER, [acces])" click-stop-propagation
		*ngIf="acces.etat === 'ETAT_EN_COURS' && (user.id === acces.cacId || user.id === acces.ccId ) && !acces.hasDemandeFermeture">
		<i class="fa-regular fa-hand fa-lg text-active"></i>
	</a>
	<a title="Autoriser la fermeture" (click)="requestAction(accesAction.FERMER, [acces])" click-stop-propagation
		*ngIf="acces.etat === 'ETAT_EN_COURS' && (user.id === acces.cacId || user.id === acces.ccId ) && acces.hasDemandeFermeture">
		<i class="fa-regular fa-thumbs-down fa-lg text-success"></i>
	</a>
	<a title="Refuser la fermeture" (click)="requestAction(accesAction.REFUSER_FERMETURE, [acces])" click-stop-propagation
		*ngIf="acces.etat === 'ETAT_EN_COURS' && (user.id === acces.cacId || user.id === acces.ccId ) && acces.hasDemandeFermeture">
		<i class="fa-regular fa-thumbs-up fa-lg text-success"></i>
	</a>
	<a title="Modifier l'accès" (click)="requestAction(accesAction.MODIFIER, [acces])" click-stop-propagation
		*ngIf="canUpdateAcces(acces)">
		<i class="fa-regular fa-pen-to-square fa-lg text-active"></i>
	</a>
	<a title="Modifier l'accès" (click)="requestAction(accesAction.FERMER, [acces])" click-stop-propagation
		*ngIf="acces.etat === 'ETAT_TERMINE' && canUpdate(acces)">
		<i class="fa-regular fa-pen-to-square fa-lg text-active"></i>
	</a>
	<a title="Associer des arrêts" (click)="requestAction(accesAction.ASSOCIER_ARRETS, [acces])" click-stop-propagation
		*ngIf="(acces.etat === 'ETAT_EN_COURS' || acces.etat === 'ETAT_TERMINE') && acces.hasCausedArrets"
		[ngClass]="acces.signalerAbsenceArrets ? 'inactive' : (acces.hasArrets ? '' : 'active')" >
		<i class="fa fa-link fa-lg"></i>
	</a>
	<a title="Associer des opérations" (click)="requestAssociation(acces)" click-stop-propagation
		*ngIf="acces.etat === 'ETAT_EN_COURS' || acces.etat === 'ETAT_TERMINE'"
		[ngClass]="acces.hasOperations ? '' : 'active'" >
		<i class="fa fa-briefcase fa-lg"></i>
	</a>
	<a title="Supprimer l'accès" (click)="requestAction(accesAction.SUPPRIMER, [acces])" click-stop-propagation
		*ngIf="canDeleteAcces(acces)">
		<i class="fa fa-trash fa-lg text-active"></i>
	</a>
	<a title="Dupliquer" (click)="requestAction(accesAction.DUPLIQUER, [acces])" click-stop-propagation >
		<i class="fa fa-clone fa-lg"></i>
	</a>
</ng-template>